import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { fetchBookingPolicy } from "@/lib/api";
import { PaymentMethodPicker } from "@/components/PaymentMethodPicker";
import { fmtPrice } from "@/lib/utils";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export const computeDeposit = (total, policy) => {
  if (!total) return 0;
  const rate = policy?.deposit_rate ?? 0.3, min = policy?.deposit_min ?? 1000;
  return Math.min(Math.max(Math.round((total * rate) / 5) * 5, min), total);
};

export const DepositPolicyDialog = ({ open, onOpenChange, total, onConfirm, busy, payOpts, onPayOptsChange }) => {
  const [policy, setPolicy] = useState(null);
  useEffect(() => { fetchBookingPolicy().then(setPolicy).catch(() => {}); }, []);
  const deposit = computeDeposit(total, policy);
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="deposit-policy-dialog" className="!bg-white !opacity-100 max-h-[90vh] overflow-y-auto" style={{ backgroundColor: "#fff" }}>
        <AlertDialogHeader>
          <AlertDialogTitle className="inline-flex items-center gap-2"><ShieldCheck className="text-emerald-600" size={20} /> Acompte Mobile Money et conditions</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-left">
              <div className="rounded-xl bg-orange-50 border border-orange-200 p-3">
                <div className="flex justify-between"><span>Total du sejour</span><b>{fmtPrice(total)}</b></div>
                <div className="flex justify-between text-orange-700"><span>Acompte a payer maintenant (30 %)</span><b data-testid="deposit-amount">{fmtPrice(deposit)}</b></div>
                {payOpts && <div className="pt-2"><PaymentMethodPicker value={payOpts} onChange={onPayOptsChange} amount={deposit} /></div>}
                <div className="flex justify-between"><span>Solde a la reception</span><b>{fmtPrice(total - deposit)}</b></div>
              </div>
              <ul className="list-disc pl-5 space-y-1">
                <li>Votre chambre est <b>bloquee {policy?.hold_minutes ?? 20} minutes</b> : sans paiement dans ce delai, elle est liberee automatiquement.</li>
                <li>Paiement securise par Orange Money, MTN MoMo, Moov ou Wave (CinetPay). SMS de confirmation apres paiement.</li>
                <li><b>Annulation :</b> gratuite dans les {policy?.penalty_grace_minutes ?? 30} minutes suivant le paiement. Au-dela, ou en cas d&apos;abandon, une <b>penalite de {Math.round((policy?.penalty_rate ?? 0.2) * 100)} % de l&apos;acompte</b> est retenue ; le reste vous est rembourse sous 72 h.</li>
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="deposit-policy-cancel">Retour</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={busy} className="btn-primary" data-testid="deposit-policy-accept">
            {busy ? "Redirection..." : `J'accepte et je paie ${fmtPrice(deposit)}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
